import React from 'react';
import {
  notEmptyString,
} from '@populateui/utils';

type Props = {
  label: string;
  value?: string | null;
};

export default function Field({ label, value }: Props) {
  return notEmptyString(value) ? (
    <div className="flex flex-col gap-0.5 min-w-[130px]">
      <span className="text-xs text-gray-500">{label}</span>
      <span className="text-xs font-semibold text-gray-700">{value}</span>
    </div>
  ) : null;
}
